module.exports = __webpack_public_path__ + "img/item1.89ed3f6b.png";